import { useEffect, useState } from 'react'

const TOTAL_SECONDS = 17 * 60 + 34

/**
 * Counts down from 00:17:34 and automatically restarts when it reaches zero.
 */
export function useCountdown() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? TOTAL_SECONDS : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  const hours = Math.floor(remaining / 3600)
  const minutes = Math.floor((remaining % 3600) / 60)
  const seconds = remaining % 60

  const pad = (n: number) => String(n).padStart(2, '0')

  return { hours: pad(hours), minutes: pad(minutes), seconds: pad(seconds) }
}
